import { type FocusEventHandler, useEffect, useState } from 'react';
import {
  CommonTextInputField,
  type CommonTextInputFieldProps,
} from './form-fields/CommonTextInputField';

interface OnChangeOnBlurTextInputProps extends CommonTextInputFieldProps {}

export function OnChangeOnBlurTextInput({
  onValueChange,
  onBlur,
  value,
  ...props
}: OnChangeOnBlurTextInputProps) {
  const [internalValue, setInternalValue] = useState(value);

  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  const onInternalBlur: FocusEventHandler<HTMLInputElement> = event => {
    onValueChange?.(internalValue ?? '');
    onBlur?.(event);
  };
  return (
    <CommonTextInputField
      {...props}
      onBlur={onInternalBlur}
      onValueChange={setInternalValue}
      value={internalValue}
    />
  );
}
